import React from 'react';

import userActions from '../redux/futures/user/actions';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CookiePage from '../pages/auth/CookiePage';
import { Switch, Route } from 'react-router-dom';
class CookieLayout extends React.Component {

    render() {
 
        return (
            <Switch>
                <Route path="/cookie" exact={true} component={CookiePage} />
            </Switch>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        
    }
}

const mapStateToProps = (state) => ({ });


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CookieLayout));